import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './index.css';

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { POSTHOG_HOST, POSTHOG_PROJECT_TOKEN } from "./utils/constants";
import { PostHogProvider } from "@posthog/react";

const container = document.getElementById("root");
const root = createRoot(container);

const posthogOptions = {
  api_host: POSTHOG_HOST,
  defaults: "2026-01-30",
};

const AppTree = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

root.render(
  POSTHOG_PROJECT_TOKEN && POSTHOG_HOST ? (
    <PostHogProvider apiKey={POSTHOG_PROJECT_TOKEN} options={posthogOptions}>
      <AppTree />
    </PostHogProvider>
  ) : (
    <AppTree />
  )
);

serviceWorker.unregister();
